import { createReducer, on, Action } from '@ngrx/store';
import * as CheckInActions from '../check-in/check-in.action';
import { ICheckIn } from 'src/app/models/check-in';

export const initialState: ICheckIn = {
};

const reducer = createReducer(
  initialState,
  on(CheckInActions.SetCheckInObjectAction, (state: ICheckIn, { checkInObj }) => ({ ...state, ...checkInObj })),
  on(CheckInActions.ClearCheckInObjectAction, (state: ICheckIn) => ({ ...initialState })),
);

export function CheckInReducer(state: ICheckIn | undefined, action: Action) {
  return reducer(state, action);
}

